import * as React from "react";
import { Dimensions, TouchableOpacity, View, StyleSheet } from "react-native";
import {
  Container,
  Header,
  Title,
  Left,
  Body,
  Right,
  Content,
  Text,
  Spinner,
} from "native-base";

import Icon from "react-native-vector-icons/FontAwesome";
import { currentLanguage } from "../../../translations/CurrentLanguage";

import CompanySettings from "@components/CompanyComponent";
import MoreSettings from "@components/MoreSettingsComponent";
import PrinterSettings from "@components/PrinterSettingsComponent";
import BluetoothScanner from "../../components/BluetoothScannerComponent";
import AddAttendant from "../../components/AddAttendantComponent";
import Sync from "../../components/SyncComponent";
import Queue from "../../components/QueueComponent";

import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);
class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      checkBoxValue: 0,
      checkBoxBluetoothValue: "disable",
      pressedTab: strings.Bluetooth,
    };
    this.onLayout = this.onLayout.bind(this);
  }

  navigate = () => this.props.navigation.navigate("DrawerOpen");

  onLayout() {
    const { width, height } = Dimensions.get("window");

    this.setState({ midComponentWidth: width * 0.5406 });
    this.setState({ rightComponentWidth: width * 0.3906 });
    this.setState({ leftComponentWidth: width * 0.0688 });
    this.setState({ screenHeight: height });
  }

  renderRow = item => {
    const selected = this.state.pressedTab === item.name;

    return (
      <TouchableOpacity
        key={item.name}
        activeOpacity={0.7}
        style={[styles.menuItem, selected ? styles.menuItemSelected : null]}
        onPress={() => {
          this.props.changeReturnValue(item.name);
          this.setState({
            pressedTab: item.name,
          });
        }}
      >
        <Text
          style={[styles.menuText, selected ? styles.menuTextSelected : null]}
        >
          {item.name}
        </Text>
        <Icon
          size={13}
          name="chevron-right"
          color={selected ? "#2563eb" : "#94a3b8"}
        />
      </TouchableOpacity>
    );
  };

  renderMenu = () => {
    const {
      // PrinterStatus
      currentAddress,
      connectionStatus,
      connected,
      connectDevice,
      checkBoxValue,
      checkBoxValueOnChange,
      availableDevices,
      availableDevicesChangeValue,
      printerStore,
      printers,
      addDevice,
      addedDevice,
      removeDevice,

      // Bluetooth Scanner
      values,
      bluetoothScannerStatus,

      // CompanySettings
      changeName,
      changeTax,
      changeHeader,
      changeFooter,
      changeCountry,
      onCompanySave,
      companyCountry,

      // Sync
      syncAll,
      onSyncEdit,
      onSyncSave,
      changeUrl,
      changeUserName,
      changePassword,
      syncEditStatus,
      url,
      user_name,
      password,
      isHttps,
      toggleHttps,

      // Attendant
      attendant,
      onDeleteAttendant,
      onClickAttendant,
      attendantsData,
      attendantsInfo,
      attendantForm,
      onChangeRoleStatus,
      roleStatus,
      rolesData,
      onAddRoles,
      onDeleteRoles,
      onClickRole,
      selectedRole,

      // Queue
      queueHost,
      setQueueHost,
      hasTailOrder,
      toggleTailOrder,
      onQueueSave,
      isEditingQueue,
      setQueueEditing,
      setQueueNotEditing,
      useDescription,
      toggleUseDescription,
      useDefaultCustomer,
      toggleUseDefaultCustomer,
      isStackItem,
      toggleIsStackItem,

      // Sync
      isSyncing,
      setDeviceId,
      deviceId,

      // navigation
      navigation,

      changeLanguage,
      companyLanguage,
      changeEditStatus,
      editStatus,
      toggleCurrencyDisabled,
      isCurrencyDisabled,
      changeNoReceipts,
      toggleItemSize,
      toggleEnableOverallTax,
      enableOverallTax,
      toggleMultipleMop,
      toggleAllowRoundOff,
      toggleHideMenuBar,
    } = this.props;

    if (this.props.returnValue === strings.Bluetooth) {
      return (
        <View>
          <PrinterSettings
            navigation={navigation}
            printers={printers}
            addDevice={addDevice}
            connected={connected}
            addedDevice={addedDevice}
            removeDevice={removeDevice}
            printerStore={printerStore}
            connectDevice={connectDevice}
            checkBoxValue={checkBoxValue}
            currentAddress={currentAddress}
            connectionStatus={connectionStatus}
            availableDevices={availableDevices}
            checkBoxValueOnChange={checkBoxValueOnChange}
            availableDevicesChangeValue={availableDevicesChangeValue}
          />
          <BluetoothScanner
            value={values}
            onCheckBoxValueChange={bluetoothScannerStatus}
          />
        </View>
      );
    }

    if (this.props.returnValue === strings.Company) {
      return this.props.loading ? (
        <Spinner color="#2563eb" />
      ) : (
        <CompanySettings
          values={values}
          changeName={changeName}
          changeNoReceipts={changeNoReceipts}
          changeTax={changeTax}
          changeHeader={changeHeader}
          changeFooter={changeFooter}
          changeCountry={changeCountry}
          changeLanguage={changeLanguage}
          companyCountry={companyCountry}
          companyLanguage={companyLanguage}
          editStatus={editStatus}
          onCompanyEdit={changeEditStatus}
          toggleCurrencyDisabled={toggleCurrencyDisabled}
          toggleEnableOverallTax={toggleEnableOverallTax}
          isCurrencyDisabled={isCurrencyDisabled}
          enableOverallTax={enableOverallTax}
          onCompanySave={() => {
            changeEditStatus(false);
            onCompanySave();
          }}
        />
      );
    }

    if (this.props.returnValue === strings.Sync) {
      return (
        <Sync
          sync={syncAll}
          onSyncEdit={onSyncEdit}
          onSyncSave={onSyncSave}
          changeUrl={changeUrl}
          isSyncing={isSyncing}
          changeUserName={changeUserName}
          changePassword={changePassword}
          syncEditStatus={syncEditStatus}
          url={url}
          user_name={user_name}
          password={password}
          isHttps={isHttps}
          toggleIsHttps={toggleHttps}
          deviceId={deviceId}
          setDeviceId={setDeviceId}
        />
      );
    }

    if (this.props.returnValue === strings.Attendant) {
      if (attendant && attendant.role === "Owner") {
        return (
          <AddAttendant
            onDeleteAttendant={onDeleteAttendant}
            onClickAttendant={onClickAttendant}
            attendantsData={attendantsData}
            attendantsInfo={attendantsInfo}
            onSave={attendantForm}
            onEdit={attendantForm}
            onChangeRoleStatus={onChangeRoleStatus}
            roleStatus={roleStatus}
            rolesData={rolesData}
            onAddRoles={onAddRoles}
            onDeleteRoles={onDeleteRoles}
            onClickRole={onClickRole}
            selectedRole={selectedRole}
          />
        );
      }
    }

    if (this.props.returnValue === strings.Queueing) {
      return (
        <Queue
          queueHost={queueHost}
          onQueueSave={onQueueSave}
          hasTailOrder={hasTailOrder}
          setQueueHost={setQueueHost}
          isEditingQueue={isEditingQueue}
          toggleTailOrder={toggleTailOrder}
          setQueueEditing={setQueueEditing}
          setQueueNotEditing={setQueueNotEditing}
          useDescription={useDescription}
          toggleUseDescription={toggleUseDescription}
          useDefaultCustomer={useDefaultCustomer}
          toggleUseDefaultCustomer={toggleUseDefaultCustomer}
          isStackItem={isStackItem}
          toggleIsStackItem={toggleIsStackItem}
        />
      );
    }
    if (this.props.returnValue === "More...") {
      return (
        <MoreSettings
          values={values}
          changeNoReceipts={changeNoReceipts}
          toggleItemSize={size => toggleItemSize(size)}
          toggleMultipleMop={size => toggleMultipleMop(size)}
          toggleAllowRoundOff={toggleAllowRoundOff}
          toggleHideMenuBar={toggleHideMenuBar}
        />
      );
    }
    return null;
  };

  render() {
    let menuItems = [
      { name: strings.Bluetooth },
      { name: strings.Company },
      { name: strings.Sync },
      { name: "More..." },
    ];

    if (this.props.attendant && this.props.attendant.role === "Owner") {
      menuItems = [
        { name: strings.Bluetooth },
        { name: strings.Company },
        { name: strings.Attendant },
        { name: strings.Sync },
        { name: strings.Queueing },
        { name: "More..." },
      ];
    }
    strings.setLanguage(currentLanguage().companyLanguage);
    return (
      <Container style={styles.screen}>
        <Header style={styles.header}>
          <Left>
            <TouchableOpacity onPress={this.navigate}>
              <Icon name="bars" size={20} color="white" style={styles.icon} />
            </TouchableOpacity>
          </Left>
          <Body style={styles.headerBody}>
            <Title>{strings.Settings}</Title>
          </Body>
          <Right>
            <TouchableOpacity onPress={() => this.props.restoreDefault()}>
              <Text style={styles.restore}>{strings.RestoreDefault}</Text>
            </TouchableOpacity>
          </Right>
        </Header>
        <View style={styles.columns}>
          <View style={styles.menu}>{menuItems.map(this.renderRow)}</View>
          <View style={styles.detail}>
            <Content padder>{this.renderMenu()}</Content>
          </View>
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: "#14213d",
  },
  icon: {
    paddingLeft: 5,
  },
  headerBody: {
    flex: 3,
  },
  view: {
    flexDirection: "row",
  },
  screen: {
    backgroundColor: "#f3f5f9",
  },
  columns: {
    flex: 1,
    flexDirection: "row",
  },
  menu: {
    width: 260,
    padding: 12,
    backgroundColor: "#fff",
    borderRightWidth: 1,
    borderRightColor: "#e3e8ef",
  },
  menuItem: {
    height: 46,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 14,
    marginBottom: 2,
    borderRadius: 12,
  },
  menuItemSelected: {
    backgroundColor: "#e8f0fe",
  },
  menuText: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#334155",
  },
  menuTextSelected: {
    color: "#2563eb",
  },
  detail: {
    flex: 1,
  },
  restore: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#9fc0ff",
  },
});

export default Settings;
